<template>
  <div>
    <div class="mt-4 mb-2" v-if="status === 1">
      <template v-if="onCredit">
        <!-- Verify Email -->
        <template v-if="!emailVerified">
          <v-btn @click="$emit('open', 'email')" color="primary" outlined>Verify email</v-btn>
        </template>
        <!-- Run Analysis -->
        <template v-else-if="doAnalysis && !analysisDone">
          <v-btn @click="$emit('open', 'eligibility')" color="primary" outlined>Run analysis</v-btn>
        </template>
        <!-- Setup collection -->
        <template v-else-if="doCollection && !collectionDone">
          <v-btn @click="$emit('open', 'repayment')" color="primary" outlined>Setup repayment</v-btn>
        </template>
        <!-- Upfront payment -->
        <template v-else>
          <v-btn @click="$emit('open', 'payment')" color="primary" outlined>
            Pay {{ amountToPay | currency }} upfront
          </v-btn>
        </template>
      </template>
      <!-- Make payment -->
      <template v-else>
        <v-btn @click="$emit('open', 'payment')" color="teal" outlined>
          Pay {{ amountToPay | currency }}
        </v-btn>
      </template>
    </div>
    <div class="text-small d-flex align-center mt-4 mb-2" v-if="status === 2">
      <v-icon color="orange" style="width:10px">mdi-circle-medium</v-icon>
      <span class="ml-2">Pending confirmation</span>
    </div>
    <template v-if="status === 3">
      <template v-if="nextPayment.amount">
        <div class="text-small d-flex align-center mt-4 mb-2">
          <v-icon color="blue" style="width:10px">mdi-circle-medium</v-icon>
          <div class="ml-2">
            Your next payment is {{ nextPayment.amount | currency }} <span v-if="nextPayment.date">{{ nextPayment.date | timeago }}</span>
          </div>
        </div>
        <NextPaymentButton class="mt-1 mb-2"/>
      </template>
      <div class="text-small d-flex align-center mt-4 mb-2" v-else>
        <v-icon color="green" style="width:10px">mdi-circle-medium</v-icon>
        <span class="ml-2">Payment is complete, you will be notified soon</span>
      </div>
    </template>
  </div>
</template>
<script>
	import NextPaymentButton from "./NextPaymentButton";

	export default {
		name: 'RequestStatus',
		components: { NextPaymentButton },
		data() {
			return {
				customer: this.$store.state.customer,
				request: this.$store.state.request,
				paying: false,
			}
		},
		methods: {
			async paymentDone(response) {
				try {
					this.paying = true;
					if (response) {
						await this.$http.post(`https://sellbackend.creditclan.com/merchantclanbackend/public/index.php/api/payment`, {
							ref_no: response.reference,
							request_id: this.request.id,
							payment_type: +this.request.payment_type + 1,
							type: 3,
							schedule_ids: this.nextPayment.ids
						});
					}
					await this.$store.dispatch("request/load", this.request.id);
					this.paying = false;
				} catch (e) {
					console.log('Payment error', e)
					this.paying = false;
				}
			},
		},
		computed: {
			onCredit() {
				return this.$store.getters['request/credit'];
			},
			status() {
				return this.$store.state.request.req_status
			},
			nextPayment() {
				return this.$store.getters["request/nextPayment"]
			},
			amountToPay() {
				return this.$store.getters["request/amountToPay"]
			},
			doCollection() {
				return this.$store.getters["request/doCollection"]
			},
			collectionDone() {
				return this.$store.getters["request/collectionDone"]
			},
			emailVerified() {
				return this.$store.getters["request/emailVerified"]
			},
			doAnalysis() {
				return this.$store.getters["request/doAnalysis"]
			},
			analysisDone() {
				return this.$store.getters["request/analysisDone"]
			},
			upfrontPaid() {
				return this.$store.getters["request/upfrontPaid"]
			},
		}
	}
</script>
